import React, { useState } from "react"
import { useLocation, useNavigate } from "react-router-dom"
import logoEntrepreneurs from "../../assets/images/header__logo-entrepreneurs.svg"
import logoV3 from "../../assets/images/header__logo_v1.svg"
import logoV2 from "../../assets/images/header__logo_v2.svg"
import defaultLogo from "../../assets/images/svg/logo.svg"
import { Variants } from "../../configs/configs.types"
import { useAppSelector } from "../../store"
import { Burger } from "../../UI/Burger"
import { BurgerV0 } from "../../UI/BurgerV0/BurgerV0"
import { Nav } from "../../UI/Nav"
import { getDomain } from "../../utils/getTld"
import "./header.sass"
import { IHeader } from "./Header.types"

// Incash (cz v4, и весь регион ro) — remote-конфиг про этот бренд не знает, лого своё.
const INCASH_LOGO = "/incash/incash_logo_webpage.svg"

export const Header: React.FC<IHeader> = React.memo(
  ({ activeLink, sticky = true, logo = defaultLogo }) => {
    const navigate = useNavigate()
    const { pathname } = useLocation()
    const [isOpen, setIsOpen] = useState(false)

    const { step } = useAppSelector(state => state.mainData)
    const configLogo = useAppSelector(state => state.configs.general.data?.header?.logo)
    const isIncashBrand =
      (process.env.REACT_APP_VARIANT ?? Variants.v0) === "v4" || getDomain() === "ro"
    const resolvedLogo = isIncashBrand ? INCASH_LOGO : configLogo || logo

    const openMenu = (isOpen: boolean) => {
      setIsOpen(isOpen)
    }

    const isMainHeader = activeLink !== undefined
    const variant = process.env.REACT_APP_VARIANT ?? Variants.v0

    if (variant === "v1") {
      const headerLogo = pathname.includes("pujcka-pro-podnikatele")
        ? logoEntrepreneurs
        : configLogo || logoV3
      return (
        <header className="header">
          <img className="header-logo" src={headerLogo} alt="logo" width={240} height={60} />
          {isMainHeader && step < 2 && (
            <>
              <Nav isOpen={isOpen} openMenuBurger={openMenu} activeLink="answer" />
              <Burger isOpen={isOpen} openMenuBurger={openMenu} />
            </>
          )}
        </header>
      )
    }

    if (variant === "v2") {
      return (
        <header className={`header ${sticky ? "sticky" : ""}`}>
          <div className="header-container-v2">
            <img
              src={configLogo || logoV2}
              alt="logo"
              className="header-logo"
              width={135}
              height={40}
              loading="lazy"
            />
            {isMainHeader && step < 2 && (
              <>
                <Nav isOpen={isOpen} openMenuBurger={openMenu} activeLink={activeLink} />
                <Burger isOpen={isOpen} openMenuBurger={openMenu} />
              </>
            )}
          </div>
        </header>
      )
    }

    if (variant === "v3") {
      return (
        <header className="header">
          <img
            className="header-logo"
            src={configLogo || logoV3}
            alt="logo"
            width={240}
            height={60}
          />
          {isMainHeader && step < 2 && (
            <>
              <Nav isOpen={isOpen} openMenuBurger={openMenu} activeLink={activeLink} />
              <Burger isOpen={isOpen} openMenuBurger={openMenu} />
            </>
          )}
        </header>
      )
    }

    return (
      <header
        className={`header ${sticky ? "sticky" : ""}`}
        style={{
          background: isMainHeader
            ? "#FFF"
            : variant === "v5"
              ? "linear-gradient(#0A3D24, #1B5E3B)"
              : "linear-gradient(#481f73, #5f4d72)"
        }}
      >
        <div className="container">
          <img
            src={resolvedLogo}
            alt="logo"
            className="logo"
            style={
              {
                // filter: !activeLink ? 'hue-rotate(180deg) brightness(0) invert(1)' : undefined
              }
            }
            width="200"
            height="82"
            loading="lazy"
            onClick={() => navigate("/")}
          />
          {isMainHeader && step < 2 && (
            <>
              <Nav isOpen={isOpen} openMenuBurger={openMenu} activeLink={activeLink} />
              <BurgerV0 isOpen={isOpen} openMenuBurger={openMenu} />
            </>
          )}
        </div>
      </header>
    )
  }
)
